import styles from "../../common/Page.module.css";
import ListBoardPreview from "Page/common/ListBoardPreview";

export default function SupportMain() {
  return (
    <div className={styles.Main}>
      <ListBoardPreview
        title="공지사항"
        category_id="1"
        api="support"
        to="support/category"
      />
      <ListBoardPreview
        title="자료실"
        category_id="2"
        api="support"
        to="support/category"
      />
      <ListBoardPreview
        title="Q&A"
        api="support/qna"
        to="support/qna/articles"
      />
    </div>
  );
}
